/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  HistoryIndexResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary History index
 */
export const listHistories = (

 signal?: AbortSignal
) => {


      return axiosClient<HistoryIndexResponse>(
      {url: `/histories`, method: 'GET', signal
    },
      );
    }




export const getListHistoriesQueryKey = () => {
    return [
    'histories'
    ] as const;
    }


export const getListHistoriesQueryOptions = <TData = Awaited<ReturnType<typeof listHistories>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHistories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListHistoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listHistories>>> = ({ signal }) => listHistories(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listHistories>>, TError, TData>
}

export type ListHistoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listHistories>>>
export type ListHistoriesQueryError = ErrorType<void>


/**
 * @summary History index
 */

export function useListHistories<TData = Awaited<ReturnType<typeof listHistories>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listHistories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListHistoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






